export class Constants {
    static INCOMING = 'Incoming';
    static RINGING = 'Ringing';
    static CONNECTING = 'Connecting';
    static CONNECTED = 'Connected';
    static DEFAULT_IMG_WIDTH = 200;
    static CROP_MEDIA = 'Crop';
    static CONFIGURATION_LOCAL_VIDEO_PREVIEW_ID = 'ConfigurationLocalVideoPreview';
    static LOCAL_VIDEO_PREVIEW_ID = 'LocalVideoPreview';
    static MINI_HEADER_WINDOW_WIDTH = 490;
    static DOMINANT_PARTICIPANTS_COUNT = 7; // The media gallery is design to work between 1 and 8 dominant participants inclusive
    static STARTED = 'STARTED';
    //Use this code if you have to implement pause/resume recording
    /*static PAUSED = 'PAUSED';    
      static RESUMED = 'RESUMED';*/
    static STOPPED = 'STOPPED';
    static STARTING = 'starting';
    static SCREENSHARE = true;
}
